export const SocialCardLogoAnimation = {
  hidden: { opacity: 0, y: 50 },
  visibleOne: {
    opacity: 1,
    y: -85,
    transition: { duration: 0.3, ease: "easeOut" },
  },
  visibleTwo: {
    y: -52,
    x: 20,
    transition: { duration: 0.5, ease: "easeOut" },
  },
  hiddenAfterVisible: {
    y: 50,
    x: 0,
    opacity: 0,
    zIndex: -1,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};

export const TextAnimation = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0 },
  transition: { duration: 0.5 },
};

export const SocialCardLogoMobAnimation = {
  hidden: { opacity: 0, y: 50 },
  visibleOne: {
    opacity: 1,
    y: -55,
    transition: { duration: 0.3, ease: "easeOut" },
  },
  visibleTwo: {
    y: -35,
    x: 20,
    transition: { duration: 0.5, ease: "easeOut" },
  },
  hiddenAfterVisible: {
    y: 50,
    x: 0,
    opacity: 0,
    zIndex: -1,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};
